import { useQuery } from "urql";
import { graphql } from "../../gql";

const songnumbersBySongbookQuery = graphql(`
  query songnumbersBySongbookQuery($bucket: String!, $songbookId: ID!) {
    songnumbersBySongbookId(bucket: $bucket, songbookId: $songbookId) {
      mnemonicNumber
      song {
        id
        title
      }
    }
  }
`);

export function useSongnumbersBySongbookQuery(
  bucket: string,
  songbookId: string | null,
): {
  songnumbers: readonly { mnemonicNumber: string; songTitle: string }[];
  fetching: boolean;
  errorMessage?: string;
} {
  const [result] = useQuery({
    query: songnumbersBySongbookQuery,
    variables: { bucket, songbookId: songbookId || "" },
    pause: !songbookId, // Don't execute query if no songbook is selected
  });

  const { data, fetching, error } = result;

  return {
    songnumbers:
      data?.songnumbersBySongbookId?.map(
        (item: { mnemonicNumber: string; song: { title: string } }) => ({
          mnemonicNumber: item.mnemonicNumber,
          songTitle: item.song.title,
        }),
      ) ?? [],
    fetching,
    errorMessage: error?.message,
  };
}
